import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import SEO from "@/components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiError(error) {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") {
    if (detail === "invalid_credentials") return "Identifiants incorrects.";
    if (detail === "too_many_login_attempts") return "Trop de tentatives. Réessayez dans quelques minutes.";
    return detail;
  }
  return "Connexion impossible. Vérifiez vos identifiants puis réessayez.";
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(() => navigate("/admin/devis", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin/devis", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Espace administrateur | DMZ Normandie" description="Espace privé de gestion des demandes de devis DMZ Normandie." path="/admin/login" robots="noindex,nofollow" />
      <section className="min-h-screen bg-[#0A0A0A] pt-40 pb-24 px-6">
        <div className="max-w-md mx-auto border border-white/10 bg-[#0D0D0D] p-8 md:p-10" data-testid="admin-login-card">
          <div className="w-12 h-12 rounded-full bg-[#C4A484]/10 border border-[#C4A484]/30 flex items-center justify-center mb-6">
            <LockKeyhole size={20} className="text-[#C4A484]" />
          </div>
          <h1 className="font-serif-display font-light text-4xl text-[#F5F5F0] mb-3">Espace Devis</h1>
          <p className="text-sm font-light text-zinc-500 mb-8">Connexion réservée à l'administration DMZ Normandie.</p>

          {checking ? (
            <div className="flex items-center gap-3 text-zinc-500 text-sm" data-testid="admin-session-check">
              <Loader2 size={16} className="animate-spin" /> Vérification de la session…
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
              <input type="email" required autoComplete="email" placeholder="E-mail administrateur" value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" data-testid="admin-email-input" />
              <input type="password" required minLength={8} autoComplete="current-password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" data-testid="admin-password-input" />
              {error && <p className="text-sm text-red-300 border border-red-400/20 bg-red-500/10 px-4 py-3" data-testid="admin-login-error">{error}</p>}
              <button type="submit" disabled={loading} className="btn-sable w-full" data-testid="admin-login-submit">
                {loading ? <><Loader2 size={16} className="animate-spin" /> Connexion…</> : "Se connecter"}
              </button>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
